export enum ENsiDictCode {
  SUBSYSTEMS = 'SUBSYSTEMS',
}
